// Kontextueller Bewertungs-Hinweis für Insights-Artikel: verlinkt thematisch passende
// Ressourcen von Valuate (valuate.daaniyalkhan.com) — Branchen-Multiples, M&A-Wissen,
// Bewertungs-Check. Navy-Variante der Förder-Box (gleiche Gold/Navy-Farbwelt), damit
// beide Boxen in einem Artikel visuell unterscheidbar bleiben.
// Artikel sind deutschsprachig, daher deutsche Copy ohne i18n.
const BewertungsHinweis = ({ text, links }) => (
  <aside className="not-prose my-10 rounded-xl border border-[#0F1B2D]/20 bg-[#0F1B2D]/5 p-6">
    <p className="text-xs font-semibold uppercase tracking-wider text-[#0F1B2D] mb-2">
      Bewertungs-Tipp
    </p>
    <p className="text-gray-800 leading-relaxed">{text}</p>
    <p className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold">
      {links.map((l) => (
        <a
          key={l.href}
          href={l.href}
          className="text-[#0F1B2D] underline decoration-[#C5A66A] underline-offset-4 hover:text-[#C5A66A] transition-colors"
        >
          {l.label} →
        </a>
      ))}
    </p>
  </aside>
);

export default BewertungsHinweis;
